import React from "react";
import { useNavigate } from "react-router-dom";
import { AuthenticationWrawper } from "src/components/AuthenticationWrawper";

const Login = () => {
  /** redux store useDispatch & useSelector ------------------------------ **/
  const navigate = useNavigate();

  return (
    <AuthenticationWrawper>
      <>
        <div className="successForgotTitles" style={{ paddingTop: 100 }}>
          Congratulations!
        </div>
        <div className="successForgotTitles" style={{ lineHeight: 0.8 }}>
          Your password has been reset successfully.
        </div>
        <div className="successForgotTitles" style={{ marginTop: 10 }}>
          Click <b>NEXT</b> to sign-in
        </div>
        <div className="successForgotTitles" style={{ lineHeight: 0.8 }}>
          with your new password.
        </div>
        <div className="d-flex flex-row justify-content-end successbtnmain">
          <div className="d-flex flex-column btndivforsuccess">
            <button
              onClick={() => navigate("/login")}
              className="d-flex justify-content-center align-items-center"
              type="submit"
            >
              NEXT
              <i className="bi bi-arrow-right-short arrow-size-for-login"></i>
            </button>
            <div className="d-flex justify-content-end">
              <i className="bi bi-caret-right-fill fold-button-styling"></i>
            </div>
          </div>
        </div>
      </>
    </AuthenticationWrawper>
  );
};

export default Login;
